import { GetAllPortfolioCompanies } from '../../common/api/PortcoAPIHelper';
import { GetAllInvestments } from '../../common/api/InvestmentAPIHelper';
import { GetAllFunds } from '../../common/api/FundAPIHelper';

export const fetchPortcos = async () => {
    try {
        const data = await GetAllPortfolioCompanies();
        //const data = JSON.parse(response.body);

        // Transform the data as per your needs...
        const transformedData = data.map(item => {
            return {
                portco_id: item.portco_id,
                company_name: item.company_name,
                company_legal_name: item.company_legal_name,
                pitchbook_id: item.pitchbook_id,
                website_url: item.website_url,
                website_blurb: item.website_blurb,
                show_on_public_website: item.show_on_public_website,
                highlight_on_public_website: item.highlight_on_public_website
            };
        });

        return transformedData;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const fetchFundsWithInvestments = async () => {
    try {
        const [fundsResponse, investments, portfolioCompaniesResponse] = await Promise.all([GetAllFunds(), GetAllInvestments(), GetAllPortfolioCompanies()]);
        
        console.log("PortfolioCompaniesHelper :: fetchFundsWithInvestments :: Start");
        console.log('fundsResponse', fundsResponse);
        console.log('investments', investments);
        console.log('portfolioCompaniesResponse', portfolioCompaniesResponse);

        const funds = JSON.parse(fundsResponse.body);
        
        console.log('parsed funds', funds);

        // Create a new data structure
        const data = funds.map(fund => {
            const relatedInvestments = investments.filter(investment => investment.internal_fund_id === fund.internal_fund_id);
            console.log('relatedInvestments for fund', fund.internal_fund_id, relatedInvestments);

            const relatedPortfolioCompanies = relatedInvestments.map(investment => investment.portco_id).filter((value, index, self) => self.indexOf(value) === index).length;
            
            return {
                fund_name: fund.fund_name,
                num_portfolio_companies: relatedPortfolioCompanies,
                total_investment: relatedInvestments.reduce((total, current) => total + current.investment_amount, 0),
            };
        });
        console.log("PortfolioCompaniesHelper :: fetchFundsWithInvestments :: End", data);

        return data;

    } catch (error) {
        console.error(error);
        return null;
    }
};

